import { QueryClient } from '@tanstack/react-query';

// Single shared QueryClient for the whole app. Defaults are tuned for
// this app's data shape: the hierarchy lookups this phase wraps (disease/
// finding names + filter-ID sets) change rarely within a session relative to
// how often they're re-requested by repeated navigation, so a longer
// staleTime avoids refetch storms without risking meaningfully stale data.
// `refetchOnWindowFocus` is disabled since re-fetching the whole disease/
// finding hierarchy every time the browser tab regains focus isn't needed
// for this kind of reference data. A 4xx (not found, logged out, rate limited)
// won't change on a retry, so only network errors and 5xx are retried.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
      retry: (failureCount, error) =>
        failureCount < 1 && !(error && error.status >= 400 && error.status < 500),
    },
  },
});

export default queryClient;
